import React from 'react';
import './ProjectCard.css';

const ProjectCard = ({ project, animationDelay }) => {
  return (
    <div
      className="project-card animated"
      style={{ animationDelay: `${animationDelay}s` }}
    >
      <h3>{project.title}</h3>
      <p>{project.description}</p>
      <button>Details</button>
    </div>
  );
};

export default ProjectCard;
